














































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'

@Component
export default class CMMFImport extends Mixins(BaseVue) {
  @Prop()
  activeSalesOrg!: number

  @Prop()
  dialog!: boolean

  // CMMF upload attributes
  public cmmfFiles = []
  public errors: string[] = []
  public loading = false
  public excelTemplatePath = require('@/assets/files/CMMF_Import_template.xlsx')

  @Watch('dialog')
  public onDialogToggle () {
    this.cmmfFiles = []
    this.errors = []
    this.loading = false
  }

  public uploadCmmfs () {
    const fileName = 'cmmfList.xlsx'
    const fileData = this.cmmfFiles[0]
    if (!fileName || fileData) {
      this.loading = true
      serviceModule.cmmfApi
        .uploadCmmfs(
          this.activeSalesOrg,
          { data: fileData, fileName: fileName }
        )
        .then(response => {
          if (response.errors?.length) {
            this.displayError(this.$t('promotionCMMF.uploadErrors'))
            this.errors = response.errors
            this.loading = false
          } else {
            this.$emit('cmmfsImported', response.data)
            this.closeDialog()
          }
        })
    }
  }

  public closeDialog () {
    this.$emit('update:dialog', false)
  }
}
